import { FC } from 'react';
import { Grid } from '@mui/material';
import {
  HealthDataTable,
  PatientInfoCard,
  PatientInfoNotes,
  PatientNextScanCard,
  PatientProgressionCard,
  BraceSensorDataCard,
  PatientQuestionnairesWidget,
} from '../../components';
import { FDADashboardTable } from '../../../functionalDynamicAssessment/components/FDADashboardTable';
import { PatientScansWidget } from '../../../scan';
import { usePatientContext } from '../../containers/PatientContainer/usePatientContext';
import { PatientHeader } from './PatientScreenHeader';
import { useAccountContext } from '../../../account';

export const PatientScreen: FC = () => {
  const { patient } = usePatientContext();
  const { user } = useAccountContext();

  const questionnairesEnabled =
    patient?.questionnaire_data?.organization_uses_questionnaires;

  const showBraceSensorCard = Boolean(
    patient?.has_brace_sensor_data || patient?.brace_sensor_name
  );

  const functionalAnalysisEnabled = user?.functional_analysis_enabled;

  return (
    <>
      <PatientHeader
        id={patient.id.toString()}
        first_name={patient.first_name}
        last_name={patient.last_name}
      />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Grid container spacing={4}>
            <Grid item xs={showBraceSensorCard ? 8 : 12}>
              <PatientProgressionCard
                hasBraceSensorData={showBraceSensorCard}
              />
            </Grid>
            {showBraceSensorCard && (
              <Grid item xs={4}>
                <BraceSensorDataCard />
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid item xs={4} lg={3}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <PatientNextScanCard />
            </Grid>
            <Grid item xs={12}>
              <PatientInfoCard />
            </Grid>
            <Grid item xs={12}>
              <PatientInfoNotes />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={8} lg={9}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <PatientScansWidget title='Scan History' patient={patient.id} />
            </Grid>
            {functionalAnalysisEnabled && (
              <Grid item xs={12}>
                <FDADashboardTable patientView={true} patient={patient.id} />
              </Grid>
            )}
            <Grid item xs={12}>
              <HealthDataTable patient={patient.id} />
            </Grid>
            <Grid item xs={12}>
              {questionnairesEnabled && <PatientQuestionnairesWidget />}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
